/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/heading-has-content */

import { useLocation, useNavigate, useParams } from "react-router-dom";
import WebsiteFooter from "common/layout/websiteFooter";
import {  useRef } from "react";
import Markdown from "react-markdown";
import { SeoProvider } from "features/components/utils/seoContext";
import { SeoMetaDecorator } from "features/components/utils/seoMetaDecorator";

import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import KroBackButton from "features/components/buttons/kroBackButton";
import useGetArticles from "features/landing/presentation/hooks/useGetArticles";
import { Articles } from "features/landing/data/models/article";
import { useGetArticle } from "features/landing/presentation/hooks/useGetArticle";
import KroLoadingIndicator, { LoaderType } from "features/components/loader/kroCircularIndicator";
import NextReadCard from "../components/fundraiserBlog/nextReadCard";

  const FundraiserBlogDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const stateArticle = state as Articles;
  const { slug } = useParams<{ slug: string }>();
  const { data: articles } = useGetArticles();
  const { data: articleData, isLoading: isLoadingArticle } = useGetArticle(
    slug ?? "",
  );

  // Use fetched article data if available, otherwise fall back to state data
  const article = articleData?.data[0] || stateArticle;

  console.log(article?.content);

  // Refs for content
  const contentRef = useRef<HTMLDivElement>(null);


if(isLoadingArticle) {
  return <KroLoadingIndicator type={LoaderType.FIXED} />;
}



  return (
    <>
     
      <SeoProvider
        value={{
          title: article?.seo?.metaTitle || "",
          description: article?.seo?.metaDescription || "",
          url: window.location.href,
          shareImage: article?.seo?.sharedImage?.data?.attributes?.url
            ? `${process.env.REACT_APP_STRAPI_URL}${article.seo.sharedImage.data.attributes.url}`
            : "",
          keywords: article?.seo?.keywords?.replaceAll(",", " ") || "",
          preventIndexing: article?.seo?.preventIndexing || false,
        }}
      >
        <SeoMetaDecorator />
        <div className=" mx-[16px] lg:mx-auto lg:max-w-[871px] mt-[40px] flex flex-col lg:mt-[80px] lg:gap-[64px]">
          
            <div className="flex items-start justify-start py-4">
              <KroBackButton
                onclick={() => navigate(-1)}
                title="Back"
              />
             
             
          </div>
            <img
              src={`${process.env.REACT_APP_STRAPI_URL}${article.cover?.formats?.large?.url}`}
              alt={"blog post cover"}
              className="lg:max-h-[332px] max-h-[265px] w-full max-w-full rounded-[8px] object-cover"
            />
         
        </div>

        <div className="mx-[16px] flex flex-col lg:mx-[75px] lg:flex-row lg:gap-[32px]">
          <div ref={contentRef} className="w-full flex-1">
            <div className="mt-[32px] flex flex-col gap-[16px] lg:mt-0 lg:flex-row lg:items-start">
              <div className="flex-1"></div>
            </div>
            <div className="flex flex-col gap-[16px] lg:items-start">
              <div className="prose prose-lg mx-auto max-w-none overflow-hidden lg:mt-8 lg:max-w-[870px]">
                <Markdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={{
                    blockquote: ({ node, ...props }) => (
                      <blockquote
                        className="my-4 border-l-4 border-[#022928] pl-4"
                        style={{ fontStyle: 'italic' }}
                        {...props}
                      />
                    ),
                    p: ({ node, ...props }) => (
                      <p className="my-4" {...props} />
                    ),
                    h1: ({ node, ...props }) => (
                      <h1 className="my-4 text-[30px] font-bold" {...props} />
                    ),
                    h2: ({ node, ...props }) => (
                      <h2 className="my-4 text-[24px] font-bold" {...props} />
                    ),
                    h3: ({ node, ...props }) => (
                      <h3 className="my-4 text-[20px] font-bold" {...props} />
                    ),
                    h4: ({ node, ...props }) => (
                      <h4 className="my-4 text-[18px] font-bold" {...props} />
                    ),
                    h5: ({ node, ...props }) => (
                      <h5 className="my-4 text-[16px] font-bold" {...props} />
                    ),
                    h6: ({ node, ...props }) => (
                      <h6 className="my-4 text-[14px] font-bold" {...props} />
                    ),
                    hr: ({ node, ...props }) => (
                      <hr className="my-4" {...props} />
                    ),
                    br: ({ node, ...props }) => (
                      <br className="my-4" {...props} />
                    ),
                    strong: ({ node, ...props }) => (
                      <strong className="my-4" {...props} />
                    ),
                    em: ({ node, ...props }) => (
                      <em className="my-4" {...props} />
                    ),
                    ul: ({ node, ...props }) => (
                      <ul className="my-4 list-disc pl-6" {...props} />
                    ),
                    ol: ({ node, ...props }) => (
                      <ol className="my-4 list-decimal pl-6" {...props} />
                    ),
                    li: ({ node, ...props }) => (
                      <li className="my-2" {...props} />
                    ),
                    a: ({ node, ...props }) => (
                      <a
                        className="text-[#022928] underline hover:text-[#022928]/80"
                        target="_blank"
                        rel="noopener noreferrer"
                        {...props}
                      />
                    ),
                    img: ({ node, ...props }) => (
                      <img
                        className="my-4 rounded-[10px]"
                        src={node?.properties?.src as string}
                        alt={node?.properties?.alt as string}
                        {...props}
                      />
                    ),
                    span: ({ node, ...props }) => (
                      <span className="my-4" {...props} />
                    ),
                  }}
                >
                  {article?.content || ""}
                </Markdown>
                <NextReadCard articles={articles?.pages.flatMap((page) => page.data) || []} slug={slug || ""} />
              </div>
            </div>
          </div>
        </div>
        

        <div className="mx-[16px] mt-[56px] lg:mx-[75px] lg:mt-[128px]">
        
        </div>
        <div className="mt-[80px] lg:mt-[128px]">
          <WebsiteFooter />
        </div>
      </SeoProvider>
    </>
  );
};

export default FundraiserBlogDetails;